import { createFileRoute, redirect } from '@tanstack/react-router';

/** Catalog setup opens on its first tab. */
export const Route = createFileRoute('/_authed/_active/org/catalog-setup/')({
  beforeLoad: () => {
    throw redirect({ to: '/org/catalog-setup/attributes' });
  },
});
